import React from 'react';
import testimonialsData from '../data/testimonials.json';

function Testimonials() {
  const { hero, intro, items, cta } = testimonialsData;

  return (
    <div className="fade-in">
      <div className="hero">
        <h1>{hero.title}</h1>
        <p>{hero.subtitle}</p>
      </div>

      <div className="content-section container">
        <h2>{intro.title}</h2>
        <p style={{ textAlign: 'center', fontSize: '1.1rem', marginBottom: '3rem' }}>
          {intro.text}
        </p>

        <div className="testimonials-container">
          {items.map((testimonial) => (
            <div key={testimonial.id} className="testimonial-card">
              <div className="testimonial-header">
                <div className="testimonial-icon">💬</div>
                <div className="testimonial-badge">{testimonial.program}</div>
              </div>
              <p className="testimonial-text">"{testimonial.text}"</p>
              <div className="testimonial-footer">
                <strong>{testimonial.name}</strong>
                <span className="testimonial-location">📍 {testimonial.location}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="content-section container call-to-action-section">
        <h2 style={{ color: '#FF9933' }}>{cta.title}</h2>
        <p style={{ fontSize: '1.1rem', marginBottom: '2rem' }}>
          {cta.text}
        </p>
        <a href={cta.href} className="btn">{cta.label}</a>
      </div>
    </div>
  );
}

export default Testimonials;
